<template>
  <v-data-table
    :headers="headers"
    :items="seguimiento_detalles"
    class="elevation-1"
  >
    <template v-slot:items="props">
      <!-- <td class="text-xs-center">10</td> -->
      <td class="text-xs-center">{{ $moment(props.item._created_at).format("DD/MM/YYYY HH:mm") }} </td>
      <td class="text-xs-center">{{ props.item.estado.descripcion }}</td>
      <td class="text-xs-center">{{ props.item.persona.nombres }} {{ props.item.persona.ap_paterno }} {{ props.item.persona.ap_materno }}</td>
    </template>
  </v-data-table>
</template>

<script>
export default {
	props: {
    seguimiento_detalles: {
      type: Array,
      default: () => []
    }
	},
	data () {
		return {
			headers: [
				// { text: 'Número', sortable: false, align: 'center'},
				{ text: 'Fecha de registro', sortable: false, align: 'center' },
				{ text: 'Estado', sortable: false, align: 'center' },
				{ text: 'Usuario Registro', sortable: false, align: 'center' },
			]
		}
	},
  async verSeguimiento(id_permiso) {
      
        try {
        let res = await this.$service.graphql({
          query: `query{
						vSeguimientoPermisos(id_permiso: ${id_permiso}){	
								rows{
							id
							id_permiso
							fecha_registro
							estado
							}
						}
						}
					`,
        });
        
        this.permiso_seguimiento = res.vSeguimientoPermisos.rows;
        //console.log('SSSSSSSSSSSS');
        //console.log(this.permiso_seguimiento);
      } catch (error) {
        console.log(error);
      }
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/permiso/components/SeguimientoDetalle.vue